import { render, staticRenderFns } from "./SrNavigationBarItem.vue?vue&type=template&id=2fc73d08"
import script from "./SrNavigationBarItem.vue?vue&type=script&lang=js"
export * from "./SrNavigationBarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports